/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkDeleteFacilityServiceAreasResponse } from './BulkDeleteFacilityServiceAreasResponse';
import {
    BulkDeleteFacilityServiceAreasResponseFromJSON,
    BulkDeleteFacilityServiceAreasResponseFromJSONTyped,
    BulkDeleteFacilityServiceAreasResponseToJSON,
    BulkDeleteFacilityServiceAreasResponseToJSONTyped,
} from './BulkDeleteFacilityServiceAreasResponse';

/**
 * 
 * @export
 * @interface BulkDeleteFacilityServiceAreas200Response
 */
export interface BulkDeleteFacilityServiceAreas200Response {
    /**
     * 
     */
    data?: BulkDeleteFacilityServiceAreasResponse;
}

/**
 * Check if a given object implements the BulkDeleteFacilityServiceAreas200Response interface.
 */
export function instanceOfBulkDeleteFacilityServiceAreas200Response(value: object): value is BulkDeleteFacilityServiceAreas200Response {
    return true;
}

export function BulkDeleteFacilityServiceAreas200ResponseFromJSON(json: any): BulkDeleteFacilityServiceAreas200Response {
    return BulkDeleteFacilityServiceAreas200ResponseFromJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreas200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteFacilityServiceAreas200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : BulkDeleteFacilityServiceAreasResponseFromJSON(json['data']),
    };
}

export function BulkDeleteFacilityServiceAreas200ResponseToJSON(json: any): BulkDeleteFacilityServiceAreas200Response {
    return BulkDeleteFacilityServiceAreas200ResponseToJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreas200ResponseToJSONTyped(value?: BulkDeleteFacilityServiceAreas200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BulkDeleteFacilityServiceAreasResponseToJSON(value['data']),
    };
}

